import React from 'react';

function GreenArrowUp(props: object) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="6"
        cy="6"
        r="6"
        transform="matrix(-1 8.74228e-08 8.74228e-08 1 12 0)"
        fill="#38D900"
        fillOpacity="0.3"
      />
      <path
        d="M6.6 10C6.6 10.3314 6.33137 10.6 6 10.6C5.66863 10.6 5.4 10.3314 5.4 10L6.6 10ZM5.57574 2.2424C5.81005 2.00809 6.18995 2.00809 6.42426 2.2424L10.2426 6.06078C10.477 6.29509 10.477 6.67499 10.2426 6.90931C10.0083 7.14362 9.62843 7.14362 9.39411 6.90931L6 3.51519L2.60589 6.90931C2.37157 7.14362 1.99167 7.14362 1.75736 6.90931C1.52304 6.67499 1.52304 6.29509 1.75736 6.06078L5.57574 2.2424ZM5.4 10L5.4 2.66667L6.6 2.66667L6.6 10L5.4 10Z"
        fill="#38D900"
      />
    </svg>
  );
}

export default GreenArrowUp;
